export const SAMPLES_FILTERS_STORAGE_KEY = "samplesFilters";
export const KIT_SAMPLES_FILTERS_STORAGE_KEY = "kitSamplesFilters";
